



















































































































































import { Component } from "vue-property-decorator";
import SingleFileHolder from "@/components/new_style_components/SingleFileHolder.vue";
import PortalCheckbox from "@/components/new_style_components/PortalCheckbox.vue";
import DictionarySelect from "@/components/new_style_components/DictionarySelect.vue";
import PortalSelect from "@/components/new_style_components/PortalSelect.vue";
import PortalTextarea from "@/components/new_style_components/PortalTextarea.vue";
import PortalInput from "@/components/new_style_components/PortalInput.vue";
import SublimeSearch from "@/components/new_style_components/SublimeSearch.vue";
import PRIL_DTO from "@/dto/request/pril/PRIL_DTO";
import PersonDTO from "@/dto/person/PersonDTO";
import Application from "@/state/Application";
import PRILService from "@/services/request/PRILService";
import { ifValid, processError } from "@/utils/ComponentUtils";
import PRILExtension from "@/mixins/PRILExtension";
import { prettyEnum } from "@/utils/StringUtils";
import moment from "moment";
import EditPRILPayload from "@/dto/request/pril/EditPRILPayload";
import RouteNames from "@/router/RouteNames";
import AdminService from "@/services/AdminService";
import SelectOption, {OptionsBuilder} from "@/components/common/SelectOption";
import SublimeOfficeDTO from "@/dto/sublime/office/SublimeOfficeDTO";
import {PRILPriority} from "@/constants/request/PRILConstants";
import PortalDate from "@/components/new_style_components/PortalDate.vue";
import ChangeCompanyModal from "@/components/pril/ChangeCompanyModal.vue";

@Component({
  components: {
    PortalDate,
    PortalTextarea,
    PortalSelect,
    PortalInput,
    DictionarySelect,
    PortalCheckbox,
    SingleFileHolder,
    SublimeSearch,
    ChangeCompanyModal,
  },
  computed: {
    moment() {
      return moment
    }
  },
  methods: {
    PRILPriority(){
      return PRILPriority;
    },
    ob() {
      return OptionsBuilder
    },
    prettyEnum
  }
})
export default class PRILInitialProcessing extends PRILExtension {

  private pril = new PRIL_DTO();
  private prilPayload = new EditPRILPayload();
  private locations: Array<SublimeOfficeDTO> = [];
  private isWorkRequired = true;

  async mounted(): Promise<void> {
    await this.loadPRIL();
    await this.loadOffices();
  }

  loadPRIL(): void {
    Application.startLoading();
    PRILService.getLetterById(this.prilId).then(
      resp => {
        this.pril = resp.data;
        this.prilPayload.letterType = resp.data.letterType.id;
        Application.stopLoading();
      },
      error => processError(error, this)
    )
  }

  loadOffices(): void {
    Application.startLoading();
    AdminService.getAllOffices().then(
      resp => {
        this.locations = resp.data;
        Application.stopLoading();
      },
      error => processError(error, this)
    );
  }

  saveNewPostal(): void {
    ifValid(this, () => {
      Application.startLoading();
      PRILService.updateLetter(this.prilId, this.prilPayload).then(
        resp => {
          Application.stopLoading();
          this.goToPostalList();
        },
        error => processError(error, this)
      )
    });
  }

  assigneeChanged(assignee: PersonDTO): void {
    this.prilPayload.assigneeId = assignee.id;
  }

  goToPostalList(): void {
    this.$router.push({ name: RouteNames.POSTREG });
  }

  get prilId(): number {
    return Number.parseInt(this.$route.params.id);
  }

  get buildLocations(): Array<SelectOption> {
    return this.locations.map(location => SelectOption.builder().title(location.title).value(location.id).build());
  }

  showChangeCompanyModal(): void {
    this.$modal.show(
      ChangeCompanyModal,
      {
        prilId: this.prilId,
        onSuccess: () => this.loadPRIL()
      },
      {
        height: 'auto',
        width: '600px'
      }
    );
  }
}
